import { generateSetChild, generateUpdateArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'
import { formatLines } from '@/utils/format'

export default {
	namespaced: true,
	state: {
		vouchers: null,
		tokenValue: null,
		balance: null
	},
	actions: {
		async loadVouchers({ state, commit, rootState }, { accumulatorGroup = null } = {}) {
			commit('setVouchers', { item: null })
			const result = await service.loadVouchers({ brand: config.BRAND, accumulatorGroup })
			commit('setVouchers', { item: result })
		},
		async orderVouchers({ commit, dispatch }, { vouchers, printAtHome, shippingAddress, billingAddress, email, notes, sendAsGift, giftSender, giftReceiver, giftMessage1, giftMessage2, giftMessage3, accumulatorGroup = null } = {}) {
			let giftMessage = formatLines([giftMessage1, giftMessage2, giftMessage3], '\n')
			const result = await service.orderVouchers({ vouchers, printAtHome, shippingAddress, billingAddress, email, notes, sendAsGift, giftSender, giftReceiver, giftMessage, brand: config.BRAND, accumulatorGroup })
			commit('setTokenValue', { item: result.tokenValue })

			dispatch('redirect', {
				name: 'checkout-token',
				params: {
					basketToken: result.tokenValue
				}
			}, {root: true})
		},
		async checkVoucherBalance({ commit }, { cardNumber } = {}) {
			commit('setBalance', { item: null });
			const result = await service.checkVoucherBalance({ cardNumber });
			commit('setBalance', { item: result.balance });
		},
		async reloadVoucher({ commit, dispatch }, { cardNumber, amount, cvc } = {}) {
			const result = await service.reloadVoucher({ cardNumber, amount, cvc, brand: config.BRAND });
			commit('setTokenValue', { item: result.tokenValue })

			dispatch('redirect', {
				name: 'checkout-token',
				params: {
					basketToken: result.tokenValue
				}
			}, {root: true})
		}
	},
	getters: {
		vouchers (state) {
			return state.vouchers || []
		},
		balance (state) {
			return state.balance
		}
	},
	mutations: {
		setVouchers: generateSetChild("vouchers"),
		setTokenValue: generateSetChild("tokenValue"),
		setBalance: generateSetChild("balance"),
	}
}
